// extracted by mini-css-extract-plugin
export default {"showMore":"styles_showMore__kwc1q","showMore__wrapper":"styles_showMore__wrapper__FqsYe"};